const pairs = [['PV_HT', 'PV_TTC'], ['PA_HT', 'PA_TTC']];
const valid = value => typeof value === 'number' && Number.isFinite(value);
const money = value => Math.round((value + Number.EPSILON) * 100) / 100;

// A TVA change keeps HT as the reference. Hidden purchase prices are never touched.
export function articlePriceChanges(key, value, current, excluded = []) {
  const patch = { [key]: value };
  const rate = key === 'TVA' ? value : current.TVA;
  if (!valid(rate) || rate < 0) return patch;
  const factor = 1 + rate / 100;
  for (const [ht, ttc] of pairs) {
    if (excluded.includes(ht) || excluded.includes(ttc)) continue;
    if (key === ht && valid(value)) patch[ttc] = money(value * factor);
    if (key === ttc && valid(value)) patch[ht] = money(value / factor);
    if (key === 'TVA' && valid(current[ht])) patch[ttc] = money(current[ht] * factor);
  }
  return patch;
}
